module.exports = __webpack_public_path__ + "img/et.04cf27d6.svg";